import { Box, Typography } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import React from 'react';

interface SearchResultItemProps {
  icon?: SvgIconComponent;
  label: string;
  subtitle?: string;
}

const SearchResultItem: React.FC<SearchResultItemProps> = ({ icon: Icon, label, subtitle }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
    {Icon && (
      <Box sx={{ mr: 1, display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
        <Icon sx={{ fontSize: 20 }} />
      </Box>
    )}
    <Box sx={{ flex: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {label}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  </Box>
);

export default SearchResultItem;
